import {
  type DigitalCancellationFormResponse,
  getEnecoBeXapiSiteApiV1OrdersDigitalCancellationBySalesOrderNumber,
} from '@eneco/dc-be/client';

import { createCancelOrderDetailsRequest } from './cancelOrderPrefillRequest';

export const fetchCancelOrderDetails = async (
  salesOrderNumber: string,
  lastName: string,
): Promise<DigitalCancellationFormResponse | undefined> => {
  const { data } = await getEnecoBeXapiSiteApiV1OrdersDigitalCancellationBySalesOrderNumber(
    createCancelOrderDetailsRequest(salesOrderNumber, lastName),
  );

  return data?.data;
};
